module.exports = {
  random: require('./random'),
  math: require('./math'),
  penplot: require('./penplot.js'),
  geometry: require('./geometry.js'),
  shader: require('./shader.js'),
  color: require('./color.js')
};
